import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query/react";
import { loginApi } from "./api/login";
import authSlice from "./authSlice";
import { SalesOrderApi } from "./api/flipkart/salesOrder";
import { SalesReturnApi } from "./api/flipkart/salesReturn";
import { companyApi } from "./api/company";
import { PaymentReceiveOrderApi } from "./api/flipkart/paymentReceiveOrder";
import { skuApi } from "./api/sku";
import { ActualReturnApi } from "./api/flipkart/actualReturn";
import { OrderItemApi } from "./api/flipkart/orderItem";
import appSlice from "./appSlice";
import {
  TypedUseSelectorHook,
  useSelector as useReduxSelector,
} from "react-redux";
import { messageApi } from './api/message';
import { categoryApi } from "./api/category";
import { subSkuApi } from "./api/subSku";
import { skuDocApi } from "./api/skuDocument";
import { purchaseApi } from "./api/purchase";
import { vendorApi } from "./api/vendor";
import { vendorTdsApi } from "./api/vendorTds";
import { paymentTermsApi } from "./api/paymentTerms";
import { vendorBankDetailApi } from "./api/vendorBankDetail";
import { vendorBillApi } from "./api/vendorBill";
import { brokerApi } from "./api/broker";
import { accountApi } from "./api/accounts";
import { itemsApi } from "./api/items";
import { accountTypeApi } from "./api/accountType";
import { adjustStockApi } from "./api/adjustStock";
import { MeeshoSalesOrderApi } from "./api/meesho/salesOrder";
import { MeeshoSalesReturnApi } from "./api/meesho/salesReturn";
import { PaymentApi } from "./api/meesho/paymentOrder";
import { MeeshoActualReturnApi } from "./api/meesho/actualReturn";
import { documentApi } from "./api/document";
import { MeeshoOrderApi } from "./api/meesho/meeshoOrder";
import { AmazonSalesOrderApi } from "./api/amazon/salesOrder";
import { AmazonSalesReturnApi } from "./api/amazon/salesReturn";
import { AmazonPaymentApi } from "./api/amazon/payment";
import { OrderItemApiAmazon } from "./api/amazon/amazonOrder";
import { AmazonactualReturnApi } from "./api/amazon/amazonActualReturn";
import { DashboardApi } from "./api/dashboard";
import { skuGroupApi } from "./api/skuGroup";
import { subSkuGroupApi } from "./api/subSkuGroup";
import { userApi } from "./api/user";
import { MeeshoAllCompanyApi } from "./api/meesho/allCompanyDashboard";
import { FlipkartAllCompanyApi } from "./api/flipkart/allCompanyDashboard";
import { AmazonAllCompanyApi } from "./api/amazon/allCompanyDashboard";
import { AllCompanyApi } from "./api/all-company";
import { skuAllCompanyApi } from "./api/skuAllCompany";
import { SupportTicketApi } from "./api/supportTicket";
import { planApi } from "./api/plan";

export const store = configureStore({
  reducer: {
    auth: authSlice,
    app: appSlice,
    [loginApi.reducerPath]: loginApi.reducer,
    [SalesOrderApi.reducerPath]: SalesOrderApi.reducer,
    [SalesReturnApi.reducerPath]: SalesReturnApi.reducer,
    [PaymentReceiveOrderApi.reducerPath]: PaymentReceiveOrderApi.reducer,
    [companyApi.reducerPath]: companyApi.reducer,
    [skuApi.reducerPath]: skuApi.reducer,
    [categoryApi.reducerPath]: categoryApi.reducer,
    [ActualReturnApi.reducerPath]: ActualReturnApi.reducer,
    [OrderItemApi.reducerPath]: OrderItemApi.reducer,
    [subSkuApi.reducerPath]: subSkuApi.reducer,
    [skuDocApi.reducerPath]: skuDocApi.reducer,
    [purchaseApi.reducerPath]: purchaseApi.reducer,
    [vendorApi.reducerPath]: vendorApi.reducer,
    [vendorBankDetailApi.reducerPath]: vendorBankDetailApi.reducer,
    [vendorTdsApi.reducerPath]: vendorTdsApi.reducer,
    [paymentTermsApi.reducerPath]: paymentTermsApi.reducer,
    [vendorBillApi.reducerPath]: vendorBillApi.reducer,
    [brokerApi.reducerPath]: brokerApi.reducer,
    [accountApi.reducerPath]: accountApi.reducer,
    [itemsApi.reducerPath]: itemsApi.reducer,
    [accountTypeApi.reducerPath]: accountTypeApi.reducer,
    [adjustStockApi.reducerPath]: adjustStockApi.reducer,
    [MeeshoSalesOrderApi.reducerPath]: MeeshoSalesOrderApi.reducer,
    [MeeshoSalesReturnApi.reducerPath]: MeeshoSalesReturnApi.reducer,
    [MeeshoActualReturnApi.reducerPath]: MeeshoActualReturnApi.reducer,
    [PaymentApi.reducerPath]: PaymentApi.reducer,
    [documentApi.reducerPath]: documentApi.reducer,
    [MeeshoOrderApi.reducerPath]: MeeshoOrderApi.reducer,
    [AmazonSalesOrderApi.reducerPath]: AmazonSalesOrderApi.reducer,
    [AmazonSalesReturnApi.reducerPath]: AmazonSalesReturnApi.reducer,
    [AmazonPaymentApi.reducerPath]: AmazonPaymentApi.reducer,
    [OrderItemApiAmazon.reducerPath]: OrderItemApiAmazon.reducer,
    [AmazonactualReturnApi.reducerPath]: AmazonactualReturnApi.reducer,
    [messageApi.reducerPath]: messageApi.reducer,
    [DashboardApi.reducerPath]:DashboardApi.reducer,
    [skuGroupApi.reducerPath]:skuGroupApi.reducer,
    [subSkuGroupApi.reducerPath]:subSkuGroupApi.reducer,
    [userApi.reducerPath]:userApi.reducer,
    [MeeshoAllCompanyApi.reducerPath]:MeeshoAllCompanyApi.reducer,
    [FlipkartAllCompanyApi.reducerPath]:FlipkartAllCompanyApi.reducer,
    [AmazonAllCompanyApi.reducerPath]:AmazonAllCompanyApi.reducer,
    [AllCompanyApi.reducerPath]:AllCompanyApi.reducer,
    [skuAllCompanyApi.reducerPath]:skuAllCompanyApi.reducer,
    [SupportTicketApi.reducerPath]:SupportTicketApi.reducer,
    [planApi.reducerPath]: planApi.reducer,

  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(loginApi.middleware)
      .concat(SalesOrderApi.middleware)
      .concat(SalesReturnApi.middleware)
      .concat(PaymentReceiveOrderApi.middleware)
      .concat(companyApi.middleware)
      .concat(skuApi.middleware)
      .concat(categoryApi.middleware)
      .concat(ActualReturnApi.middleware)
      .concat(OrderItemApi.middleware)
      .concat(subSkuApi.middleware)
      .concat(skuDocApi.middleware)
      .concat(purchaseApi.middleware)
      .concat(vendorApi.middleware)
      .concat(vendorTdsApi.middleware)
      .concat(paymentTermsApi.middleware)
      .concat(vendorBankDetailApi.middleware)
      .concat(vendorBillApi.middleware)
      .concat(brokerApi.middleware)
      .concat(accountApi.middleware)
      .concat(accountTypeApi.middleware)
      .concat(itemsApi.middleware)
      .concat(adjustStockApi.middleware)
      .concat(MeeshoSalesOrderApi.middleware)
      .concat(MeeshoSalesReturnApi.middleware)
      .concat(MeeshoActualReturnApi.middleware)
      .concat(PaymentApi.middleware)
      .concat(documentApi.middleware)
      .concat(MeeshoOrderApi.middleware)
      .concat(AmazonSalesOrderApi.middleware)
      .concat(AmazonSalesReturnApi.middleware)
      .concat(AmazonPaymentApi.middleware)
      .concat(OrderItemApiAmazon.middleware)
      .concat(AmazonactualReturnApi.middleware)
      .concat(messageApi.middleware)
      .concat(DashboardApi.middleware)
      .concat(skuGroupApi.middleware)
      .concat(subSkuGroupApi.middleware)
      .concat(userApi.middleware)
      .concat(MeeshoAllCompanyApi.middleware)
      .concat(FlipkartAllCompanyApi.middleware)
      .concat(AmazonAllCompanyApi.middleware)
      .concat(AllCompanyApi.middleware)
      .concat(skuAllCompanyApi.middleware)
      .concat(SupportTicketApi.middleware)
      .concat(planApi.middleware)

});

export const resetAllState = () => {
  store.dispatch(SalesOrderApi.util.resetApiState());
  store.dispatch(SalesReturnApi.util.resetApiState());
  store.dispatch(PaymentReceiveOrderApi.util.resetApiState());
  store.dispatch(companyApi.util.resetApiState());
  store.dispatch(skuApi.util.resetApiState());
  store.dispatch(categoryApi.util.resetApiState());
  store.dispatch(ActualReturnApi.util.resetApiState());
  store.dispatch(OrderItemApi.util.resetApiState());
  store.dispatch(subSkuApi.util.resetApiState());
  store.dispatch(purchaseApi.util.resetApiState());
  store.dispatch(vendorApi.util.resetApiState());
  store.dispatch(vendorBankDetailApi.util.resetApiState());
  store.dispatch(vendorTdsApi.util.resetApiState());
  store.dispatch(paymentTermsApi.util.resetApiState());
  store.dispatch(vendorBankDetailApi.util.resetApiState());
  store.dispatch(vendorBillApi.util.resetApiState());
  store.dispatch(brokerApi.util.resetApiState());
  store.dispatch(accountApi.util.resetApiState());
  store.dispatch(accountTypeApi.util.resetApiState());
  store.dispatch(itemsApi.util.resetApiState());
  store.dispatch(adjustStockApi.util.resetApiState());
  store.dispatch(MeeshoSalesOrderApi.util.resetApiState());
  store.dispatch(MeeshoSalesReturnApi.util.resetApiState());
  store.dispatch(MeeshoActualReturnApi.util.resetApiState());
  store.dispatch(PaymentApi.util.resetApiState());
  store.dispatch(documentApi.util.resetApiState());
  store.dispatch(MeeshoOrderApi.util.resetApiState());
  store.dispatch(AmazonSalesOrderApi.util.resetApiState());
  store.dispatch(AmazonSalesReturnApi.util.resetApiState());
  store.dispatch(AmazonPaymentApi.util.resetApiState());
  store.dispatch(OrderItemApiAmazon.util.resetApiState());
  store.dispatch(AmazonactualReturnApi.util.resetApiState());
  store.dispatch(messageApi.util.resetApiState());  
  store.dispatch(DashboardApi.util.resetApiState());
  store.dispatch(skuGroupApi.util.resetApiState());
  store.dispatch(subSkuGroupApi.util.resetApiState());
  store.dispatch(userApi.util.resetApiState());
  store.dispatch(MeeshoAllCompanyApi.util.resetApiState())
  store.dispatch(FlipkartAllCompanyApi.util.resetApiState())
  store.dispatch(AmazonAllCompanyApi.util.resetApiState())
  store.dispatch(AllCompanyApi.util.resetApiState())
  store.dispatch(skuAllCompanyApi.util.resetApiState())
  store.dispatch(SupportTicketApi.util.resetApiState())

  
};

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;
